import { useMediaQuery } from "@/hooks/use-media-query";
import { ConfigWidgetMargins } from "../types/config";

export const WidgetWrapper = ({
  children,
  margins,
}: {
  children: React.ReactNode;
  margins: ConfigWidgetMargins | undefined;
}) => {
  const isMobile = useMediaQuery("(max-width: 768px)");
  const bottomMargin = isMobile
    ? margins?.mobileBottom || 12
    : margins?.bottom || 44;
  const rightMargin = isMobile
    ? margins?.mobileRight || 12
    : margins?.right || 44;
  const width = isMobile ? `calc(100vw - ${rightMargin * 2}px)` : "auto";

  return (
    <div
      className="nut-fixed nut-z-50 !nut-text-[16px]"
      style={{
        bottom: bottomMargin,
        right: rightMargin,
        width,
        maxWidth: 400,
      }}
    >
      <div
        className="nut-relative nut-w-full nut-flex nut-items-end nut-justify-end"
        style={{ height: 'auto' }}
      >
        {children}
      </div>
    </div>
  );
};
